import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinmumbai() {



    const cardData = {





keyword: "Best Cab Service in Mumbai",

headingDescription: "Shreesha Tours & Travels provides the Best Cab Service in Mumbai for local travel, airport transfers, corporate transportation, family trips, business meetings, wedding transportation, sightseeing tours, one-way journeys, round trips, and outstation travel across Maharashtra. We offer a wide range of chauffeur-driven vehicles including Sedan, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Tempo Traveller, Urbania, Mini Bus, and luxury cars to meet every travel requirement. With professional drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free travel experience. Whether you are planning a weekend getaway, pilgrimage tour, corporate trip, family vacation, or long-distance journey from Mumbai, our reliable cab services provide smooth transportation with complete comfort and convenience.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most popular outstation destinations from Mumbai, known for IT parks, educational institutes, historical forts, temples, and attractions like Shaniwar Wada, Aga Khan Palace, and Sinhagad Fort."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is a famous beach destination offering beautiful beaches, churches, forts, resorts, nightlife, and water activities. It is a preferred choice for family holidays, couples, and group trips."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is known for the famous Mahalaxmi Temple, Panhala Fort, Rankala Lake, traditional culture, and delicious Maharashtrian cuisine. It is a popular destination for religious and leisure travel."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a scenic hill station near Mumbai famous for waterfalls, caves, viewpoints, trekking spots, and beautiful green valleys, making it perfect for weekend trips."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station famous for strawberry farms, Venna Lake, Pratapgad Fort, viewpoints, and pleasant weather throughout the year."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is a major pilgrimage destination famous for Sai Baba Temple, Dwarkamai, Chavadi, and spiritual attractions. It is one of the most booked religious routes from Mumbai."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, Panchavati, temples, and scenic surroundings. It is popular for religious tours and weekend vacations."
  },
  {
    title: "Mumbai to Aurangabad",
    description: "Aurangabad is famous for Ajanta and Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and historical monuments. It is an excellent destination for heritage tours."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal getaway known for beaches, sea forts, resorts, and water activities. It is one of the most preferred short trips from Mumbai."
  },
  {
    title: "Mumbai to Ratnagiri",
    description: "Ratnagiri is a scenic Konkan destination famous for Ganpatipule Temple, beaches, forts, Alphonso mango orchards, and beautiful coastal landscapes."
  }
],




"services": [
  {
    "name": "Best Cab Service in Mumbai",
    "description": "Book the Best Cab Service in Mumbai for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cars for local rides, airport transfers, corporate travel, family trips, sightseeing, and outstation journeys with convenient booking options."
  },
  {
    "name": "Top Cab Service Mumbai",
    "description": "Choose Top Cab Service Mumbai for dependable transportation with experienced drivers, clean vehicles, and affordable fares. Get comfortable cab solutions for daily travel, business meetings, airport pickup and drop, weekend trips, and long-distance journeys across Maharashtra and India."
  },
  {
    "name": "Mumbai Taxi Service",
    "description": "Book Mumbai Taxi Service for convenient city travel with professional drivers and comfortable vehicles. Whether you need local transportation, airport transfers, office travel, shopping trips, or sightseeing, enjoy smooth and hassle-free taxi services available throughout Mumbai."
  },
  {
    "name": "Mumbai Cab Booking",
    "description": "Complete Mumbai Cab Booking with easy online reservations, quick confirmation, and multiple vehicle options. Select the perfect cab according to your travel needs and enjoy reliable transportation for local trips, airport transfers, corporate travel, and outstation destinations."
  },
  {
    "name": "Reliable Cab Service Mumbai",
    "description": "Choose Reliable Cab Service Mumbai for safe and punctual travel with trained chauffeurs, well-maintained cars, and transparent pricing. Get dependable cab services for personal travel, family journeys, business trips, airport transfers, and long-distance transportation."
  },
  {
    "name": "Professional Taxi Service Mumbai",
    "description": "Hire Professional Taxi Service Mumbai for comfortable journeys with experienced chauffeurs and quality vehicles. Our taxi services provide reliable transportation solutions for corporate travel, local rides, airport transfers, sightseeing tours, and special occasions."
  },
  {
    "name": "Affordable Cab Service Mumbai",
    "description": "Book Affordable Cab Service Mumbai for budget-friendly travel with excellent comfort and safety. Enjoy competitive fares, clean AC vehicles, skilled drivers, and flexible booking options for local, airport, and outstation travel requirements."
  },
  {
    "name": "Mumbai Local Cab Service",
    "description": "Choose Mumbai Local Cab Service for convenient city transportation with quick pickup and reliable drivers. Perfect for daily commuting, shopping, meetings, railway station transfers, and local sightseeing across Mumbai."
  },
  {
    "name": "Mumbai Outstation Cab Service",
    "description": "Book Mumbai Outstation Cab Service for comfortable long-distance travel with premium vehicles and professional chauffeurs. Travel safely to destinations across Maharashtra and India with one way, round trip, family, and corporate cab options."
  },
  {
    "name": "Mumbai Airport Cab Service",
    "description": "Reserve Mumbai Airport Cab Service for timely pickup and drop facilities from Mumbai International Airport. Enjoy smooth airport transfers with luggage-friendly vehicles, experienced drivers, and 24x7 availability for domestic and international travelers."
  },
  {
    "name": "Mumbai One Way Cab Service",
    "description": "Choose Mumbai One Way Cab Service for affordable drop taxi solutions without return fare charges. Enjoy comfortable one way travel with professional chauffeurs, clean vehicles, flexible pickup locations, and reliable service."
  },
  {
    "name": "Mumbai Round Trip Cab Service",
    "description": "Book Mumbai Round Trip Cab Service for return journeys with flexible schedules and comfortable vehicles. Ideal for family vacations, weekend trips, sightseeing tours, pilgrimage travel, and business journeys requiring dependable transportation."
  },
  {
    "name": "Mumbai Corporate Cab Service",
    "description": "Select Mumbai Corporate Cab Service for professional business transportation including employee travel, client visits, meetings, airport transfers, and corporate events. Get punctual service, premium vehicles, and trained chauffeurs for all corporate travel needs."
  },
  {
    "name": "Mumbai Family Cab Service",
    "description": "Book Mumbai Family Cab Service for safe and comfortable travel with spacious vehicles suitable for families. Enjoy convenient transportation for vacations, functions, airport transfers, sightseeing, and outstation family trips with experienced drivers."
  },
  {
    "name": "Mumbai 24x7 Cab Service",
    "description": "Get Mumbai 24x7 Cab Service for round-the-clock transportation with reliable drivers and well-maintained vehicles. Whether you need early morning airport transfers, late-night travel, emergency rides, or planned journeys, enjoy dependable cab availability anytime."
  },
  {
    "name": "Online Cab Booking Mumbai",
    "description": "Complete Online Cab Booking Mumbai with fast reservations, instant confirmation, and flexible vehicle choices. Book comfortable cabs for local travel, airport transfers, corporate trips, family outings, and outstation journeys with easy online service."
  }
],
"tableData": [
  ["Best Cab Service in Mumbai", "Top Cab Service Mumbai"],
  ["Mumbai Taxi Service", "Mumbai Cab Booking"],
  ["Reliable Cab Service Mumbai", "Professional Taxi Service Mumbai"],
  ["Affordable Cab Service Mumbai", "Mumbai Local Cab Service"],
  ["Mumbai Outstation Cab Service", "Mumbai Airport Cab Service"],
  ["Mumbai One Way Cab Service", "Mumbai Round Trip Cab Service"],
  ["Mumbai Corporate Cab Service", "Mumbai Family Cab Service"],
  ["Mumbai 24x7 Cab Service", "Online Cab Booking Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Best Cab Service in Mumbai for Comfortable Travel",
    WhyChoosedescription: "Shreesha Travels provides reliable and professional cab services in Mumbai for airport transfers, local travel, corporate transportation, family outings, sightseeing tours, and outstation journeys. Our well-maintained cars and experienced chauffeurs ensure a smooth travel experience for every passenger."
  },
  {
    WhyChooseheading: "Complete Taxi Solutions Under One Roof",
    WhyChoosedescription: "From daily city rides to long-distance trips, we offer a complete range of travel solutions including local cabs, airport taxis, one-way drops, round trips, rental cars, corporate travel, and customized tour packages."
  },
  {
    WhyChooseheading: "Premium Fleet for Every Travel Need",
    WhyChoosedescription: "Choose from comfortable Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses based on your journey type and group size."
  },
  {
    WhyChooseheading: "Reliable Airport & Corporate Cab Services",
    WhyChoosedescription: "Our Mumbai cab services are ideal for airport pickups, hotel transfers, business meetings, client transportation, conferences, exhibitions, and executive travel requirements with timely and professional assistance."
  },
  {
    WhyChooseheading: "Outstation Trips from Mumbai Made Easy",
    WhyChoosedescription: "Plan your journey from Mumbai to Pune, Goa, Nashik, Shirdi, Lonavala, Mahabaleshwar, Kolhapur, Surat, Ahmedabad, Hyderabad, Bengaluru, and other destinations with our comfortable outstation cabs."
  },
  {
    WhyChooseheading: "Experienced Drivers & Safe Journeys",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Mumbai routes, highways, and popular destinations, providing safe driving, punctual pickups, and a hassle-free travel experience."
  },
  {
    WhyChooseheading: "Clean Vehicles with Quality Service",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before travel to maintain high standards of safety, comfort, and reliability."
  },
  {
    WhyChooseheading: "Book Your Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy easy booking, transparent pricing, flexible travel options, and dependable transportation whenever you need the best cab service in Mumbai."
  }
]

};

const faqData = [
  {
    question: "Why choose Shreesha Travels for cab service in Mumbai?",
    answer: "Shreesha Travels offers comfortable vehicles, professional drivers, flexible booking options, and reliable transportation for local, airport, and outstation travel."
  },
  {
    question: "Which types of cabs are available in Mumbai?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicle options."
  },
  {
    question: "Do you provide Mumbai Airport taxi services?",
    answer: "Yes, we offer airport pickup and drop services for Mumbai Domestic and International Airport terminals."
  },
  {
    question: "Can I book a cab for Mumbai sightseeing?",
    answer: "Yes, we provide Mumbai Darshan cabs and customized sightseeing packages covering popular attractions and city locations."
  },
  {
    question: "Are corporate cab services available in Mumbai?",
    answer: "Yes, our corporate cab solutions support employee transportation, business meetings, client visits, and official travel requirements."
  },
  {
    question: "Can I hire a cab from Mumbai for outstation trips?",
    answer: "Yes, our outstation taxi services connect Mumbai with major destinations across Maharashtra and other states."
  },
  {
    question: "Do you provide one-way cab booking in Mumbai?",
    answer: "Yes, one-way cab services are available for direct destination travel without requiring a return journey."
  },
  {
    question: "Can I book a cab for weddings and events?",
    answer: "Yes, our vehicles are available for weddings, family functions, guest transportation, and special occasions."
  },
  {
    question: "How is the Mumbai cab fare decided?",
    answer: "The fare depends on vehicle category, travel distance, trip duration, destination, and selected service package."
  },
  {
    question: "How can I book the Best Cab Service in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback: "The cab service was excellent from booking to destination. The driver arrived on time, the vehicle was clean, and the complete journey was comfortable and stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neelam Verma",
    feedback: "A smooth and reliable travel experience with professional support. The comfortable car and polite driver made our Mumbai journey very convenient.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/best-cab-service-in-mumbai.webp",
  "description":
    "Book Best Cab Service in Mumbai with Shreesha Tours & Travels for safe, reliable, and affordable taxi solutions. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, airport transfers, corporate transportation, family trips, sightseeing tours, and outstation journeys with professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/best-cab-service-in-mumbai"
  }
};





    return (
        <div>
<Helmet>
  <title>Best Cab Service in Mumbai | Reliable Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Best Cab Service in Mumbai with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with professional drivers, affordable fares, and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Best Cab Service in Mumbai, Top Cab Service Mumbai, Mumbai Taxi Service, Mumbai Cab Booking, Reliable Cab Service Mumbai, Mumbai Best Taxi Service, Online Cab Booking Mumbai, Mumbai Airport Cab Service, Mumbai Outstation Taxi Service, Mumbai Car Rental Service, Mumbai One Way Cab, Mumbai Round Trip Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabserviceinmumbai;